import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
// import _ from 'lodash';
// import { connect } from 'react-redux';
// import { watchEvents, unWatchEvents } from './actions/query';
// import { getEventsFromInput, createCallable } from './utils';

// eslint-disable-next-line
import styles from 'ag-grid-community/dist/styles/ag-theme-fresh.css';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { columnDefs, defaultColumnDefs } from './DevoteeGrid.config';

const mapStateToProps = state => {
  const devotees = state.firestore.data.devotees;
  return ({
    devotees,
    rowData: devotees ? Object.values(devotees) : [],
  });
};

// const mapDispatchToProps = dispatch =>
//     Services.util.getDispatchActions([
//     ], dispatch);


class DevoteeGrid extends Component {

  render() {
    return (
      <div
        id="devotee-grid"
        className="ag-theme-fresh"
        style={{
          height: '100%',
          width: '100%',
        }}
      >
        <AgGridReact
          defaultColDef={defaultColumnDefs}
          deltaRowDataMode={true}
          getRowNodeId={data => data.id}
          columnDefs={columnDefs}
          rowData={this.props.rowData}>
        </AgGridReact>
      </div>
    );
  }
}

// export default connect(mapStateToProps)(DevoteeGrid);

export default compose(
  firestoreConnect(['devotees']), // or { collection: 'todos' }
  connect(mapStateToProps),
)(DevoteeGrid);
